<template>
  <div >
    <el-dialog
      :visible.sync="status"
      custom-class="muXqDEtail"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false">
      <div class="title" v-html="title"></div>
      <div class="conte" v-html="content"></div>
      <div class="btn" :style="{'left':getClientleft}">
<!--        <div class="qdBtn" @click="goTo">引用</div>-->
        <div class="qXBtn" @click="colse()">取消</div>
      </div>
    </el-dialog>
<!--    <el-dialog-->
<!--      :visible.sync="status"-->
<!--      :show-close="false"-->
<!--      @close='closeDialog'-->
<!--      custom-class="muXqDEtail"-->
<!--      :append-to-body="true"-->
<!--      :close-on-click-modal="false"-->
<!--    >-->
<!--      -->
<!--    </el-dialog>-->
  </div>
</template>

<script>
  export default {
    name: "notice",
    data() {
      return {
        id: '',
        status:false,
        title:'',
        content: '',
          getClientleft:''
      }
    },
    props: {
      isDetail: Boolean,
      idProps:String
    },
    created() {
      this.id = this.idProps
      this.status = !this.isDetail
      //  获取详情
      this.Viemoban()
      this.getClientleft = (document.body.clientWidth / 2 + 330) + 'px'
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    methods: {
      //  获取详情
      Viemoban() {
        this.$api.apiAdmin.viewArticle({
          mid: this.user.mid,
          id:this.id
        }).then(res => {
          this.title = res.data.title
          if (this.$route.query.biaoQ) {
            res.data.content = this.$tools.keywordscolorful(res.data.content, this.$route.query.biaoQ)
          }
          this.content = res.data.content
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 文章引用量+1
      yinYong(){
        this.$api.apiAdmin.useinfo({
          mid: this.user.mid,
          id: this.id
        }).then().catch()
      },
      goTo(){
        // 文章引用量+1
        this.yinYong()
        this.$router.push({
          path:'/home/zncgBanKuai',
          query:{
            id: this.id
          }
        })
      },
      colse() {
        this.status = false
        this.$emit("watchState", true)
      },
      closeDialog() {
        this.$emit("watchState", true)
      }
    },
    watch: {
      idProps() {
        this.id = this.idProps
      },
      isDetail () {
        console.log(this.isDetail)
        this.status = this.isDetail
      },
    }
  }
</script>

<style scoped lang="scss">

.title {
  width: 600px;
  margin-left: 35px;
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  border-bottom:2px solid #d4d6da;
  text-align: center;
  padding: 10px 0;
  line-height: 40px;
}
  .conte {
    margin-top: 30px;
    width: 600px;
    margin-left: 35px;
    /*height: 76vh;*/
    /*overflow: scroll;*/
  }
.btn {
    position: fixed;
    top: 160px;
    right: 0;
  .qdBtn {
    width: 110px;
    height: 38px;
    background-color: #0089ff;
    box-shadow: -1px 1px 5px 0px
    rgba(204, 59, 59, 0.45);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
   }
  .qXBtn {
    width: 110px;
    height: 38px;
    background-color: #ffffff;
    box-shadow: -1px 1px 5px 0px
    rgba(204, 59, 59, 0.45);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    color: #333;
    margin-top: 10px;
    cursor: pointer;
  }
}
</style>